export default __webpack_public_path__ + "static/01-d22401caabdd9d2ce73474f3ff00bcb9.jpg";